import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faShareAlt, faCloudDownloadAlt, faFileDownload, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import DropboxSaver from "react-dropbox-saver"
import DropboxButton from "./DropboxButton";

const Result = ({ imageData, totalPercentage, download, downloadAll, enableBtn, executeScroll, files }) => {
    const onSuccess = (file) => {
    }
    const onProgress = (val) => {
    }
    const onCancel = () => { }
    const Onerror = (err) => {
        console.log("err: ", err)
    }
    function truncateMiddle(str, frontLen = 10, backLen = 8) {
        if (str.length <= frontLen + backLen) return str;
        return str.slice(0, frontLen) + "..." + str.slice(-backLen);
    }
    function togglePercentSign(percentStr) {
        if (percentStr.startsWith('-')) {
            return '+' + percentStr.slice(1);
        } else if (percentStr.startsWith('+')) {
            return '-' + percentStr.slice(1);
        } else {
            return '-' + percentStr; // if no sign is present, treat as positive
        }
    }
    console.log("files", files)
    console.log("imageData", imageData)
    return (
        <>
            {imageData.length > 0 &&
                <div className="maincompression_view">
                    <div className="container">
                        <div className="col-xl-8 col-lg-9 col-md-11 midcolumn">
                            <div className="result_block">
                                {imageData.map((data, index) => {
                                    return (
                                        <div className="result_item" key={index.toString()}>
                                            <div className="result_detail">
                                                <h5 className="mb-0" title={data.file_name}><strong>{truncateMiddle(data.file_name)}</strong></h5>
                                                <small>{parseFloat(data.original_size) < 1000 ? `${parseFloat(data.original_size)} Bytes`
                                                    : parseFloat(data.original_size) > 1000 && parseFloat(data.original_size) < 1000000 ? `${parseFloat(parseFloat(data.original_size) / 1000).toFixed(2)} KB`
                                                        : parseFloat(data.original_size) > 1000000 ? `${parseFloat(parseFloat(data.original_size) / 1000000).toFixed(2)} MB` : ""
                                                }</small>
                                                <span className="text-uppercase badge badge-primary ml-2 p-1 px-2">{data.file_name.split(".").pop()}</span>
                                            </div>
                                            <div className={`result_download ${data.loading ? "loading" : ""}`}>
                                                {/* <div className={`result_download ${data.over || data.oversize || data.success === false ? "stopLoading" : data.success ? "" : "loading"}`}> */}
                                                {data.converted_formats && data.converted_formats.length && data.converted_formats.map((opt, i) => {
                                                    return (
                                                        <div key={i} className="result_download_item">
                                                            <div className="text-end">
                                                                <h6 className="mb-0" title={data.file_name}><strong>
                                                                    {data.oversize ?
                                                                        null :
                                                                        <>
                                                                            {data.over ?
                                                                                <a noopener="true" onClick={executeScroll}>Update <br /> Plan</a>
                                                                                :
                                                                                `${opt.compress_percentage && togglePercentSign(opt.compress_percentage)}`
                                                                            }
                                                                        </>
                                                                    }
                                                                </strong></h6>
                                                                <small>
                                                                    {opt.compress_size &&
                                                                        <>
                                                                            {parseFloat(opt.compress_size) < 1000 ? `${parseFloat(opt.compress_size)} Bytes`
                                                                                : parseFloat(opt.compress_size) > 1000 && parseFloat(opt.compress_size) < 1000000 ? `${parseFloat(parseFloat(opt.compress_size) / 1000).toFixed(1)} KB`
                                                                                    : parseFloat(opt.compress_size) > 1000000 ? `${parseFloat(parseFloat(opt.compress_size) / 1000000).toFixed(1)} MB` : ""
                                                                            }
                                                                        </>
                                                                    }
                                                                </small>
                                                            </div>
                                                            <span className="ml-1">
                                                                {data.oversize ?
                                                                    null :
                                                                    <>
                                                                        {data.over ?
                                                                            <p>Optimize now?</p>
                                                                            :
                                                                            data.success === false ?
                                                                                <a noopener="true" className="download_btn" style={{ backgroundColor: "red" }}><FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" /> {opt.format}</a>
                                                                                :
                                                                                opt.compress_percentage &&
                                                                                <a noopener="true" className="download_btn" download onClick={() => download(opt, data.file_name)}><FontAwesomeIcon icon={faFileDownload} className="mr-1" /> {opt.format}</a>
                                                                        }
                                                                    </>
                                                                }
                                                            </span>
                                                        </div>
                                                    )
                                                })}

                                                {data.success == false || data.over || data.oversize ?
                                                    <>
                                                        {data.success == false ?
                                                            <p style={{ color: "red", textTransform: "capitalize" }}><small>{data.message}</small></p>
                                                            :
                                                            <div className="progress-bar-current" style={{ color: data.over || data.oversize ? "#ff0000" : "" }}>
                                                                <span className="bar_status status_1">
                                                                    {data.over || data.oversize ? <FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" /> : null} {data.oversize ? "File too large" : data.over ? "Too many files" : ""}</span>
                                                            </div>
                                                        }
                                                    </>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>


                            {/* <div id="response" className="result table-responsive">
                                <table className="table" id='table_imges'>
                                    <thead>
                                        <tr>
                                            <th scope="col">File Name</th>
                                            <th className="heading_index" scope="col">Original</th>
                                            <th className="heading_index" scope="col">Status </th>
                                            <th className="heading_index" scope="col">Compressed</th>
                                            <th className="heading_index" scope="col">Download</th>
                                            <th className="heading_index" scope="col">%</th>
                                        </tr>
                                    </thead>
                                    <tbody id="body">
                                        {imageData.map((data, index) => {
                                            return (
                                                <tr key={index.toString()}>
                                                    <td title={data.file_name}>{data.file_name.substring(0, 20)}</td>
                                                    <td className="heading_index">
                                                        {parseFloat(data.original_size) < 1000 ? `${parseFloat(data.original_size)} Bytes`
                                                            : parseFloat(data.original_size) > 1000 && parseFloat(data.original_size) < 1000000 ? `${parseFloat(parseFloat(data.original_size) / 1000).toFixed(2)} KB`
                                                                : parseFloat(data.original_size) > 1000000 ? `${parseFloat(parseFloat(data.original_size) / 1000000).toFixed(2)} MB` : ""
                                                        }
                                                    </td>
                                                    <td className="heading_index" style={{ width: "150px" }}>
                                                        {data.success === false ?
                                                            <p style={{ color: "red", textTransform: "capitalize" }}><small>{data.message}</small></p>
                                                            :
                                                            <div className="progress-bar-current" style={{ backgroundColor: data.over || data.oversize ? "#ff0000" : "" }}>
                                                                <span className="bar_status status_1">{data.oversize ? "File size too large" : data.over ? "Too many files" : data.success ? "Completed" : "Compressing"}</span>
                                                                <div className={`heading_index progress ${data.success && "animation_stop"}`} id="file-progress_1" value="0" style={{ width: data.over || data.oversize || data.success === false ? "0%" : data.success ? "100%" : "50%" }}></div>
                                                            </div>
                                                        }
                                                    </td>
                                                    <td className="heading_index compress_size1">
                                                        {data.compress_size &&
                                                            <>
                                                                {parseFloat(data.compress_size) < 1000 ? `${parseFloat(data.compress_size)} Bytes`
                                                                    : parseFloat(data.compress_size) > 1000 && parseFloat(data.compress_size) < 1000000 ? `${parseFloat(parseFloat(data.compress_size) / 1000).toFixed(2)} KB`
                                                                        : parseFloat(data.compress_size) > 1000000 ? `${parseFloat(parseFloat(data.compress_size) / 1000000).toFixed(2)} MB` : ""
                                                                }
                                                            </>
                                                        }
                                                    </td>
                                                    <td className="heading_index">
                                                        {data.oversize ?
                                                            null :
                                                            <>
                                                                {data.over ?
                                                                    <p>Optimize now?</p>
                                                                    :
                                                                    data.compress_percentage &&
                                                                    <a noopener="true" className="download_btn" download onClick={() => download(data.compress_path, data.file_name)}>Download</a>
                                                                }
                                                            </>
                                                        }
                                                    </td>
                                                    <td className=" heading_index percentages_1">
                                                        {data.oversize ?
                                                            null :
                                                            <>
                                                                {data.over ?
                                                                    <a noopener="true" onClick={executeScroll}>Update <br /> Plan</a>
                                                                    :
                                                                    data.compress_percentage && data.compress_percentage
                                                                }
                                                            </>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                                <div className="total_cmpress" id="messages">
                                    Total Compress: {" "}
                                    <span className='total_com'>{totalPercentage}</span>%
                                </div>
                            </div> */}
                            <div className="download_image">
                                <span className="download_outer">
                                    <span className="share">
                                        <FontAwesomeIcon icon={faShareAlt} /> Share it.</span>
                                    <span className="download">
                                        <a noopener="true" href="http://www.facebook.com/sharer.php?u=https://www.pngcompressor.com/" target="_blank" className="facebook fb-share down_text btn hover_button ">
                                            <FontAwesomeIcon icon={faFacebookF} />
                                        </a>
                                    </span>
                                    <span className="download">
                                        <a noopener="true" href="https://twitter.com/intent/tweet?url=https://www.pngcompressor.com/" className="twitter fb-share down_text btn hover_button " target="_blank">
                                            <FontAwesomeIcon icon={faTwitter} />
                                        </a>
                                    </span>
                                    <span className="download">
                                        <a noopener="true" href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://www.pngcompressor.com/" target="_blank" className="facebook fb-share down_text btn hover_button ">
                                            <FontAwesomeIcon icon={faLinkedinIn} />
                                        </a>
                                    </span>
                                    <span className="download">
                                        <a noopener="true" href="mailto:admin@pngcompressor.com" noopener noreferrer className="mail fb-share down_text btn hover_button " target="_blank">
                                            <FontAwesomeIcon icon={faEnvelope} />
                                        </a>
                                    </span>
                                </span>
                                <span className="download_options">
                                    <span id="container" className="btn drop save_to_dropbox">
                                        {files.length && enableBtn ?
                                            // <DropboxSaver
                                            //     key={JSON.stringify(files)}
                                            //     appKey={'p39e0lkw7elqc5e'}
                                            //     success={files => onSuccess(files)}
                                            //     cancel={() => onCancel()}
                                            //     progress={(progress) => onProgress(progress)}
                                            //     error={(err) => Onerror(err)}
                                            //     files={files}
                                            // >
                                            //     <em className={`dropbox-dropin-btn dropbox-dropin-default dropbox-saver ${enableBtn ? "" : "disable_download"}`}><span className="dropin-btn-status">
                                            //     </span> Save to Dropbox</em>
                                            // </DropboxSaver >
                                            <DropboxButton files={files} enableBtn={enableBtn} />
                                            : null
                                        }
                                    </span>
                                    <span className="download">
                                        <button className={`down_text btn hover_button downloadAll_btn ${enableBtn ? "" : "disable_download"}`} onClick={downloadAll}>
                                            <FontAwesomeIcon icon={faCloudDownloadAlt} /> Download All
                                        </button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Result;